// extracted by mini-css-extract-plugin
export default {"hint-dropdown":"context-detail_hint-dropdown__567eA","fake-button":"context-detail_fake-button__KiUxi"};